// Geographic centroids (lat/lng) for all 58 IFTA jurisdictions.
// Used by resolveRoute.js for Haversine-based mileage distribution.
// US: 48 contiguous states. Canada: AB, BC, MB, NB, NL, NS, ON, QC, SK.
// PE is excluded — not an IFTA member jurisdiction.

export const STATE_CENTROIDS = {
  // United States (48 contiguous)
  AL: { lat: 32.806671, lng: -86.791130 },
  AZ: { lat: 34.048927, lng: -111.093731 },
  AR: { lat: 34.799999, lng: -92.199997 },
  CA: { lat: 36.778259, lng: -119.417931 },
  CO: { lat: 39.550051, lng: -105.782067 },
  CT: { lat: 41.603221, lng: -73.087749 },
  DE: { lat: 38.910832, lng: -75.527670 },
  FL: { lat: 27.994402, lng: -81.760254 },
  GA: { lat: 33.040619, lng: -83.643074 },
  ID: { lat: 44.240459, lng: -114.478828 },
  IL: { lat: 40.349457, lng: -88.986137 },
  IN: { lat: 39.849426, lng: -86.258278 },
  IA: { lat: 42.011539, lng: -93.210526 },
  KS: { lat: 38.526600, lng: -96.726486 },
  KY: { lat: 37.668140, lng: -84.670067 },
  LA: { lat: 31.169960, lng: -91.867805 },
  ME: { lat: 44.693947, lng: -69.381927 },
  MD: { lat: 39.063946, lng: -76.802101 },
  MA: { lat: 42.230171, lng: -71.530106 },
  MI: { lat: 43.326618, lng: -84.536095 },
  MN: { lat: 45.694454, lng: -93.900192 },
  MS: { lat: 32.741646, lng: -89.678696 },
  MO: { lat: 38.456085, lng: -92.288368 },
  MT: { lat: 46.879682, lng: -110.362566 },
  NE: { lat: 41.492537, lng: -99.901810 },
  NV: { lat: 38.313515, lng: -117.055374 },
  NH: { lat: 43.452492, lng: -71.563896 },
  NJ: { lat: 40.298904, lng: -74.521011 },
  NM: { lat: 34.840515, lng: -106.248482 },
  NY: { lat: 42.165726, lng: -74.948051 },
  NC: { lat: 35.630066, lng: -79.806419 },
  ND: { lat: 47.528912, lng: -99.784012 },
  OH: { lat: 40.388783, lng: -82.764915 },
  OK: { lat: 35.565342, lng: -96.928917 },
  OR: { lat: 44.572021, lng: -122.070938 },
  PA: { lat: 40.590752, lng: -77.209755 },
  RI: { lat: 41.680893, lng: -71.511780 },
  SC: { lat: 33.856892, lng: -80.945007 },
  SD: { lat: 44.299782, lng: -99.438828 },
  TN: { lat: 35.747845, lng: -86.692345 },
  TX: { lat: 31.054487, lng: -97.563461 },
  UT: { lat: 39.320980, lng: -111.093731 },
  VT: { lat: 44.045876, lng: -72.710686 },
  VA: { lat: 37.769337, lng: -78.169968 },
  WA: { lat: 47.400902, lng: -121.490494 },
  WV: { lat: 38.491226, lng: -80.954453 },
  WI: { lat: 43.784440, lng: -88.787868 },
  WY: { lat: 42.755966, lng: -107.302490 },

  // Canadian provinces (9 IFTA members)
  AB: { lat: 53.933271, lng: -116.576503 },
  BC: { lat: 53.726669, lng: -127.647621 },
  MB: { lat: 53.760860, lng: -98.813873 },
  NB: { lat: 46.498390, lng: -66.159668 },
  NL: { lat: 53.135509, lng: -57.660435 },
  NS: { lat: 44.681988, lng: -63.744311 },
  ON: { lat: 51.253775, lng: -85.232212 },
  QC: { lat: 52.939916, lng: -73.549136 },
  SK: { lat: 52.939916, lng: -106.450860 },
};
